import React from 'react';
import { UseFormRegister, FieldArrayWithId } from 'react-hook-form';
import { DeliveryNote } from '../../../types';
import Button from '../Button';
import Input from '../Input';

interface TechnicalPartTableProps {
  register: UseFormRegister<DeliveryNote>;
  fields: FieldArrayWithId<DeliveryNote, 'technicalPart', 'id'>[];
  addItem: () => void;
  removeItem: (index: number) => void;
}

const TechnicalPartTable: React.FC<TechnicalPartTableProps> = ({
  register,
  fields,
  addItem,
  removeItem,
}) => {
  return (
    <div className="card">
      <div className="card-header">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-900">Technical Part</h2>
          <Button type="button" onClick={addItem} variant="secondary" size="sm">
            Add Item
          </Button>
        </div>
      </div>
      <div className="card-body">
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">No</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Quantity</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">U. Size</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {fields.map((field, index) => (
                <tr key={field.id}>
                  <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
                    {index + 1}
                  </td>
                  <td className="px-4 py-4">
                    <Input
                      {...register(`technicalPart.${index}.type`, { required: 'Type is required' })}
                      placeholder="Item type/description"
                      className="min-w-[200px]"
                    />
                  </td>
                  <td className="px-4 py-4">
                    <Input
                      type="number"
                      step="1"
                      min="0"
                      {...register(`technicalPart.${index}.quantity`, { 
                        required: 'Quantity is required',
                        min: { value: 0, message: 'Quantity must be 0 or greater' }
                      })}
                      className="min-w-[100px]"
                    />
                  </td>
                  <td className="px-4 py-4">
                    <Input
                      {...register(`technicalPart.${index}.unitSize`)}
                      placeholder="Unit size"
                      className="min-w-[100px]"
                    />
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap">
                    {fields.length > 1 && (
                      <Button
                        type="button"
                        onClick={() => removeItem(index)}
                        variant="danger"
                        size="sm"
                      >
                        Remove
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TechnicalPartTable;
